<template>
	<div>
		<JonInfo v-if="showApplicantInterest" class="mb-3">
			<template #message><b>Super!</b> Die Person hat ihr Interesse bereits bekundet.</template>
		</JonInfo>
		<template v-if="!forceTookPlace">
			<!--<div class="mb-3">
				<div class="font-weight-bold">Teilnehmer seitens {{ companyName }} gemäß Terminplanung</div>
				<ParticipantsList :appointment="message.appointment"/>
			</div>-->
			<div class="font-weight-bold mb-2">Ergebnis:</div>
			<RadioGroup v-model="tookPlace" :options="tookPlaceOptions" stacked/>
		</template>
		<TookPlace
			v-if="appointmentTookPlace"
			:message="message"
			class="mt-4"
			@processed="$emit('processed')"
		/>
		<DidNotTakePlace
			v-if="appointmentDidNotTakePlace"
			:message="message"
			class="mt-4"
			@processed="$emit('processed')"
		/>
	</div>
</template>

<script>
import ParticipantsList from "@/vue/communication/appointment/ParticipantsList"
import RadioGroup from "@/vue/common/form/RadioGroup";
import TookPlace from "@/vue/communication/conversation/message/reply/post-appointment/CustomerTookPlace";
import DidNotTakePlace from "@/vue/communication/conversation/message/reply/post-appointment/CustomerDidNotTakePlace";
import JonInfo from "@/vue/common/JonInfo.vue";
import {APPLICANT_INTERESTED_IN_COLLABORATION} from "@/helper/communication/conversation/Status";

export default {

	components: {
		JonInfo,
		RadioGroup,
		ParticipantsList,
		TookPlace,
		DidNotTakePlace,
	},

	props: {
		message: {
			type: Object,
			required: true,
		},
		forceTookPlace: {
			type: Boolean,
			required: false,
			default: false,
		}
	},

	data ()
	{
		return {
			tookPlace: this.forceTookPlace ? true : undefined,
		};
	},

	computed: {
		showApplicantInterest ()
		{
			return this.message.conversationStatus.id === APPLICANT_INTERESTED_IN_COLLABORATION;
		},
		companyName ()
		{
			return this.message.customer.companyName;
		},
		tookPlaceOptions ()
		{
			return [
				{value: true, text: 'Der Termin hat stattgefunden'},
				{value: false, text: 'Der Termin hat nicht stattgefunden'},
			];
		},
		appointmentTookPlace ()
		{
			return this.tookPlace === true;
		},
		appointmentDidNotTakePlace ()
		{
			return this.tookPlace === false;
		},
	},
}
</script>
